import { render, staticRenderFns } from "./OrderWesmartPending.vue?vue&type=template&id=c73a5ae8&scoped=true"
import script from "./OrderWesmartPending.vue?vue&type=script&lang=js"
export * from "./OrderWesmartPending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73a5ae8",
  null
  
)

export default component.exports